const skipFilters = document.querySelector('.skip-filters');
const searchContent = document.querySelector('#main-content .ais-SearchBox-input');

if (skipFilters && searchContent) {
    skipFilters.addEventListener('click', (e) => {
        e.preventDefault();
        searchContent.focus();
    });
}
